import { Action } from 'redux'
import { takeLatest, call, all, put, select } from 'redux-saga/effects'

import { Student, StudentTypes } from './types'
import { editStudent } from './actions'

import { ecommerceApi, learningApi } from '../../../services/api'
import { RootState } from '../rootReducer'

interface EditStudentAction extends Action, Student {
  type: StudentTypes.EDIT_STUDENT_REQUEST
}

export function* editInfoStudentIdentification(info: any): any {
  try {
    const getToken = (state: RootState) => state.auth.token
    const getProfile = (state: RootState) => state.student.profile

    const token = yield select(getToken)
    const { _id } = yield select(getProfile)

    learningApi.defaults.headers.common['Authorization'] = `Bearer ${token}`

    const response = yield call(learningApi.put, `/student/identification/${_id}`, info.payload)
  } catch (error) {
    console.error(error)
  }
}

export function* editInfoStudent(info: any): any {
  try {
    const getToken = (state: RootState) => state.auth.token
    const getProfile = (state: RootState) => state.student.profile

    const token = yield select(getToken)
    const oldProfile = yield select(getProfile)
    learningApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
    ecommerceApi.defaults.headers.common['Authorization'] = `Bearer ${token}`

    const response = yield call(ecommerceApi.put, '/student', info.payload)

    const newProfile: Student = response.data

    // Para não quebrar o fluxo, reaproveitamos as infos que já estão na store(subscription, preference)
    yield put(
      editStudent({
        ...oldProfile,
        ...newProfile,
      })
    )
  } catch (error) {
    console.error(error)
  }
}

export default all([
  takeLatest<EditStudentAction>(StudentTypes.EDIT_STUDENT_REQUEST, editInfoStudent),
  takeLatest<EditStudentAction>(
    StudentTypes.EDIT_STUDENT_IDENTIFICATION,
    editInfoStudentIdentification
  ),
])
